module.exports = __webpack_public_path__ + "static/media/area_icon.89e9903e.svg";